import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Logo from "../../assets/images/logo.png";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../features/auth/authActions";
import Api from "../../admin/components/api/Api";
import { setFormData, resetStep } from "../../features/formData/formSlice";
import Avatar from "../../admin/components/notes/Avatar";
import { FaBell } from "react-icons/fa";
import "./Navigation.css"

function MainNavigation() {
  const loggedInUser = useSelector((state) => state.auth.user);
     
  const userType = loggedInUser?.user?.userType?.name;
  // const userType = loggedInUser?.userDetails?.userType;
  // const roles = loggedInUser?.userType?.name;
  const roles = loggedInUser?.user?.roles;
  // console.log("User Roles:", loggedInUser?.user?.roles); 
  // console.log("User Type:", loggedInUser?.user?.userType?.name); 
  const [userDetail, setUserDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notificationCount, setNotificationCount] = useState(null);
  const [navbarExpanded, setNavbarExpanded] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [timestamp, setTimestamp] = useState(Date.now());

  const dispatch = useDispatch();
  const navigate = useNavigate(); 

  const id = loggedInUser?.user?.id;
  // const id = loggedInUser?.userDetails?.id;

  const getDetailsApi = Api({
    url: `admin/user/id/${id}`,
  });

  const getNotificationApi = Api({
    url: `notify/getCount`,
  });

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      getDetailsApi.fetchData()
        .then(responseData => {
          setUserDetails(responseData?.data);
        })
        .catch(error => console.error("Error fetching data:", error))
        .finally(() => setIsLoading(false));
    }
  }, [id, timestamp]); // Ensure `id` is available when fetching data
  // console.log("User Details main navigation:", userDetail);
  
  useEffect(() => {
    const getNotificationData = async () => {
      try {
        const responseData = await getNotificationApi.fetchDataBySingleId();
        if (responseData?.data?.statusType === "SUCCESS") {
          setNotificationCount(responseData.data.totalRecord);
        }
      } catch (error) {
        console.error("Error fetching notification count:", error);
      }
    };

    getNotificationData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimestamp(Date.now()); // Update timestamp every 30 seconds
    }, 10000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const logoutHandler = async () => {
    try {
      const formData = {}; // Resetting form data

      dispatch(resetStep());
      dispatch(setFormData(formData)); // Dispatching action to set form data

      dispatch(logout());

      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const navLinks = [
    {
      to: "/dashboard",
      label: "Dashboard",
      allowedUserTypes: [
        "SUPER_ADMIN",
        "ALL_HOME_DESIRE",
        "PARTNER",
        "CUSTOMER",
      ],
      role: [],
    },
    {
      to: "/post",
      label: "Posts",
      allowedUserTypes: [
        "SUPER_ADMIN",
        "ALL_HOME_DESIRE",
      ],
      role: [],
    },
    {
      to: "/property",
      label: "Properties",
      allowedUserTypes: [
        "SUPER_ADMIN",
        "ALL_HOME_DESIRE",
      ],
      role: [],
    },
    {
      to: "/promotion-list",
      label: "Promotions",
      allowedUserTypes: [
        "SUPER_ADMIN",
        "ALL_HOME_DESIRE",
        "PARTNER",
      ], 
      role: [],
    },
    {
      to: `/query`,
      label: "Queries",
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE" ],
      role: [],
    },
    {
      to: `/help-center`, 
      label: "Help Center", 
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE", "PARTNER", "CUSTOMER",],
      role: [],
    }, 
    {
      to: `/user`,
      label: "Masters",
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE", "PARTNER"],
      role: ["ROLE_ADMIN"],
    },
    {
      to: `my-preference`,
      label: "Preference",
      allowedUserTypes: [
        "SUPER_ADMIN",
        "ALL_HOME_DESIRE",
        "PARTNER",
        "CUSTOMER",
      ],
      role: [],
    },
    {
      to: "/user/profile",
      label: "Profile",
      allowedUserTypes: [
        "SUPER_ADMIN",
        "ALL_HOME_DESIRE",
        "PARTNER",
        "CUSTOMER",
      ],
      role: [],
    },
  ];

  const handleSelect = () => {
    setDropdownOpen(false);
  };

  const handleLinkClick = () => {
    setDropdownOpen(false);
  };

  const handleToggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleNavClick = () => {
    setNavbarExpanded(false);
    setDropdownOpen(false);
  };

  return (
<header className="main-header sticky-top modern-navbar">
  <Navbar
    expand="lg"
    expanded={navbarExpanded}
    onToggle={() => setNavbarExpanded(!navbarExpanded)}
    className="py-2"
  >
    <Container fluid className="px-4 px-lg-5">

      {/* Logo */}
      <Navbar.Brand as={Link} to="/" className="navbar-brand-modern">
        <img src={Logo} alt="Logo" className="navbar-logo-modern" />
      </Navbar.Brand>

      {/* Toggle */}
      <Navbar.Toggle aria-controls="navbar-nav" />

      <Navbar.Collapse id="navbar-nav">
        <Nav className="ms-auto modern-nav align-items-center" onSelect={handleSelect}>

          {/* Menu Items */}
          <NavLink to="/" className="modern-link" onClick={handleNavClick}>Home</NavLink>
          <NavLink to="/about-us" className="modern-link" onClick={handleNavClick}>About Us</NavLink>
          <NavLink to="/property-list" className="modern-link" onClick={handleNavClick}>Property</NavLink>

          {/* Services Dropdown */}
          <NavDropdown title="Services" id="services-dropdown" className="modern-dropdown">
            <NavDropdown.Item as={Link} to="/interiordesign" onClick={handleNavClick}>
              Interior Design
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/property-list" onClick={handleNavClick}>
              Property
            </NavDropdown.Item>
          </NavDropdown>

          <NavLink to="/contactus" className="modern-link" onClick={handleNavClick}>Contact Us</NavLink>

          {loggedInUser?.statusType === "SUCCESS" ? (
            <>
              {/* User Dropdown */}
              <NavDropdown
                // align="end"
                title={
                  <div className="user-trigger-modern d-inline-flex align-items-center ">
                    <Avatar
                      icon={userDetail?.user?.first_name}
                      src={userDetail?.assetUrl + userDetail?.user?.photo}
                      size={40}
                    />
                    <span className="fw-semibold text-nowrap">{userDetail?.user?.first_name || "Profile"}</span>
                  </div>
                }
              >
                {navLinks
                  .filter((link) => {
                    const isAllowedUser = link.allowedUserTypes.includes(userType);
                    const isPartnerAdmin =
                      userType === "PARTNER" &&
                      roles.includes("ROLE_ADMIN") &&
                      link.allowedUserTypes.includes("PARTNER");
                    const isPartnerVisible =
                      userType !== "PARTNER" || link.role.length === 0 || roles.includes("ROLE_ADMIN");
                    return (isAllowedUser || isPartnerAdmin) && isPartnerVisible;
                  })
                  .map((link, index) => (
                    <NavDropdown.Item
                      key={index}
                      as={Link}
                      to={link.to}
                      onClick={handleNavClick}
                      className="text-capitalize"
                    >
                      {link.label}
                    </NavDropdown.Item>
                  ))}

                <NavDropdown.Divider />
                <NavDropdown.Item className="text-danger" onClick={() => { logoutHandler(); handleNavClick(); }}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>

              {/* Notifications */}
              <Link to="/notification" className="position-relative ms-lg-3">
                <FaBell size={22} />
                {notificationCount > 0 && (
                  <span className="modern-badge">{notificationCount}</span>
                )}
              </Link>
            </>
          ) : (
            <NavLink to="/login" className="modern-link ms-lg-3">
              <i className="fa fa-user-o me-1"></i> Login
            </NavLink>
          )}
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
</header>

  );
}

export default MainNavigation;
